import Vue from 'vue'
import Router from 'vue-router'
// import index from '@/components/index'
// import intro from '@/components/intro'
// import pic from '@/components/pic'
// import web from '@/components/web'

import choose from '@/views/choose/choose'
import index from '@/views/index/index'
import intro from '@/views/intro/intro'
import pic from '@/views/pic/pic'
import web from '@/views/web/web'

Vue.use(Router)

export default new Router({
    routes: [
		{
			path: '/',
			name: 'choose',
			component: choose,
		}
		,{
			path: '/index',
			name: 'index',
			component: index,
		}
		,{
			path: '/intro',
			name: 'intro',
			component: intro,
		},
		,{
			path: '/pic',
			name: 'pic',
			component: pic,
		},
		,{
			path: '/web',
			name: 'web',
			component: web,
		}
    ]
})


// WEBPACK FOOTER //
// ./src/router/index.js